const msalConfig = {
	auth: {
		clientId: process.env.VUE_APP_AZURE_APP_ID, // ApplicationID from Azure
		authority: process.env.VUE_APP_AZURE_AD_HOST_URI + '/' + process.env.VUE_APP_AZURE_TENANT_ID, // Application Tenant ID
		redirectUri: process.env.VUE_APP_URL + '/login'
	}
}

export { msalConfig }
